(function () {
  const csPdpCrossSellSelectors = {
    data: '[data-cs-pdp-cross-sell-data]',
    select: '[data-cs-pdp-cross-sell-select]',
    submitPrice: '[data-cs-pdp-cross-sell-submit-price]'
  }

  class CsPdpCrossSell extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController()
      const signal = this.abortController.signal

      const dataElement = this.querySelector(csPdpCrossSellSelectors.data)
      this.data = dataElement ? JSON.parse(dataElement.textContent) : { moneyFormat: '${{amount}}' }

      this.select = this.querySelector(csPdpCrossSellSelectors.select)
      this.submitPriceElement = this.querySelector(csPdpCrossSellSelectors.submitPrice)

      if (this.select) {
        this.select.addEventListener('change', () => this._onSelectChange(), { signal })
        this._onSelectChange()
      }
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort()
    }

    _onSelectChange() {
      if (!this.submitPriceElement) return

      const option = this.select.options[this.select.selectedIndex]
      if (!option) return

      const price = parseInt(option.dataset.unitPrice, 10)
      if (Number.isNaN(price)) return

      const parsedMultiplier = parseInt(option.dataset.purchaseMultiplier, 10)
      const purchaseMultiplier = Number.isNaN(parsedMultiplier) ? 1 : parsedMultiplier

      this.submitPriceElement.textContent = window.csPdpFormatMoney(
        price * purchaseMultiplier,
        this.data.moneyFormat
      )
    }
  }

  if (!customElements.get('cs-pdp-cross-sell')) {
    customElements.define('cs-pdp-cross-sell', CsPdpCrossSell)
  }
})()
